<script>
import { ProductionStatisticsServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'
const pssp = new ProductionStatisticsServiceProxy()
import dayjs from 'dayjs'

export default {
  data() {
    return {
      data: [],
      filter: {
        current: 1,
        size: 15
      },
      total: 0,
      innerColumns: [],
      innerData: [],
      expandedKeys: []
    }
  },
  props: {
    planId: {
      type: String,
      default: ''
    },
    scroll: {
      type: Number,
      default: 600
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('page_plan_order_no'),
          dataIndex: 'orderCode',
          key: 'orderCode',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_plan_process_production_personnel'),
          dataIndex: 'producerName',
          key: 'producerName',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_qc_product_workstaion') ||'生产工位',
          dataIndex: 'workStationName',
          key: 'workStationName',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_standard_process_procedure_code') ||'工序编码',
          dataIndex: 'processCode',
          key: 'processCode',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_three_coordinate_detection_process_name') ||'工序名称',
          dataIndex: 'processName',
          key: 'processName',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_plan_inspection_user') ||'质检人员',
          dataIndex: 'qcName',
          key: 'qcName',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_plan_inspection_time') || '质检时间',
          dataIndex: 'qcTime',
          key: 'qcTime',
          width: 120,
          ellipsis: true,
          customRender: (text) => {
            if (text) {
              return dayjs(text).format('YYYY-MM-DD HH:mm:ss')
            }
          }
        }
      ]
    }
  },
  watch: {
    planId: {
      handler() {
        if (this.planId != '') {
          this.filter.current = 1
          this.getPorcess()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getPorcess() {
      const res = await pssp.orderProcessQcReport(
        this.filter.current,
        this.planId,
        this.filter.size
      )
      this.data = res.records
      this.total = Number(res.total)
    },
    handleTableChange(value) {
      this.filter.current = value
      this.getPorcess()
    },
    showTotal(total) {
      return this.$t('Total…items').replace('{0}', total)
    },
    changeExpanded(value) {
      if (value && value.length > 1) {
        this.expandedKeys = [value[1]]
      } else {
        this.expandedKeys = value
      }
      this.innerColumns = []
      this.innerData = []
      let innDat = {}
      if (this.expandedKeys.length) {
        const item = this.data.find((res) => res.id === this.expandedKeys[0])
        if (item && item.qcItemReportVOList.length) {
          item.qcItemReportVOList.forEach((res, index) => {
            const dataIndex = 'index' + index
            const table = {
              title: res.itemName + `(${this.$t('page_standard')}/${this.$t('page_job_plan_measured')})`,
              key: index,
              dataIndex: dataIndex,
              ellipsis: true
            }
            innDat[dataIndex] = res.standardValue + '/' + res.measuredValue
            this.innerColumns.push(table)
          })
          this.innerData.push(innDat)
        }
      }
    }
  }
}
</script>

<template>
  <div style="height:100%;position: relative;">
    <div class="table-show-inner">
      <ml-table
        :columns="columns"
        :data-source="data"
        rowKey="id"
        @expandedRowsChange="changeExpanded"
        :expandedRowKeys="expandedKeys"
      >
        <a-table
          slot="expandedRowRender"
          :columns="innerColumns"
          :data-source="innerData"
          :pagination="false"
        >
        </a-table>
      </ml-table>
    </div>
    <a-pagination
      style="position:absolute;bottom: 4px;right: 20px"
      :show-total="(total) => `${showTotal(total)}`"
      :current="filter.current"
      :pageSize="filter.size"
      :total="total"
      @change="handleTableChange"
    />
  </div>
</template>

<style lang="less" scoped>
.cause-error-top {
  display: flex;
  align-content: center;
  justify-content: space-between;
  padding-bottom: 8px;
}
.table-show-inner {
  height: calc(100% - 33px);
  overflow-y: auto;
  .ant-table-wrapper{
    margin: 0;
  }
}
</style>
